import React from 'react';
import clsx from 'clsx';

import styles from './ActionToolbar.module.scss';
import { useActionRenderer } from './hooks/useActionRenderer';
import { ActionType, ActionItem, ActionToolbarVariant } from './types';

// Re-export types for backward compatibility
export type { ActionType, ActionItem, ActionToolbarVariant };

export interface ActionToolbarProps {
  actions?: ActionItem[];
  variant?: ActionToolbarVariant;
  toolbarIdentifier?: string;

  className?: string;
}

export function ActionToolbar({
  actions,
  variant = 'vertical',
  toolbarIdentifier,
  className,
}: ActionToolbarProps): JSX.Element {
  const { renderActionList } = useActionRenderer({
    variant,
    toolbarIdentifier,
  });

  if (!actions || actions.length === 0) {
    return <></>;
  }

  return (
    <ul className={clsx(styles.actionToolbar, styles[variant], className)}>
      {renderActionList(actions, 5, styles.actionItem)}
    </ul>
  );
}
